import React, { useEffect } from 'react';

// CSS
import styles from './GameStore.scss';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getGameStore } from '@Managers/Redux/AppState/AppState';
import JsonView from '@uiw/react-json-view';

function GameStore() {
    const gameStore = useAppSelector(getGameStore);
    useEffect(() => {}, [gameStore]);
    return <div className={styles.json_view}>{gameStore && <JsonView collapsed={1} value={gameStore} />}</div>;
}

export default GameStore;
